import * as React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Dashboard from "./components/DashBoard/Dashboard";
import { RequireAuth } from "./components/requiredAuth";
import RebrandingPopUp from "./components/RebrandingPopUp/rebrandingPopup";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { initRudder } from "./analytics/rudder";
import { initAnalytics } from "./analytics/trackingPlan";
import ResponseHandle from "./components/ResponseHandle/ResponseHandle";
import AuthStoreWithSSO from "./components/SsoAuth/sso";
import ConsoleLogger from "./services/otel/consoleLogger";
import { InitOtel } from "./services/otel/init";
import TraceProvider from "./services/otel/instrumentation";
import ExternalRedirect from "./redirection";
import { getInterfaceThemeClassName } from "./utils/theme";

declare global {
  interface Window {
    tvWidget: {
      showNoticeDialog: (options: {
        title: string;
        body: string;
        callback: () => void;
      }) => void;
      showConfirmDialog: (options: {
        title: string;
        body: string;
        callback: (param: boolean) => void;
      }) => void;
    };
  }
}

initRudder();
initAnalytics();


const App: React.FC = () => {
  console.log("App Rendered", "version: ", process.env.REACT_APP_COMMIT_VERSION);
  InitOtel({
    env: process.env.REACT_APP_ENV || "dev",
    name: "tv-terminal",
    version: `${process.env.REACT_APP_COMMIT_VERSION}`,
  });

  return (
    <div id="themeManage" className={getInterfaceThemeClassName()}>
      <TraceProvider>
        <ConsoleLogger />
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={true}
          newestOnTop={true}
          closeOnClick={true}
          rtl={false}
          pauseOnHover={true}
        />
        <RebrandingPopUp />
        <BrowserRouter>
          <Routes>
            {/* SSO is the only login method */}
            <Route path="/tvTerminal/sso" element={<AuthStoreWithSSO />} />

            {/* Protected routes */}
            <Route element={<RequireAuth />}>
              <Route path="/tvTerminal" element={<Dashboard />} />
            </Route>


            {/* 404 handler */}
            <Route path="*" element={<ExternalRedirect />} />
            <Route element={<ResponseHandle />} />
          </Routes>
        </BrowserRouter>
      </TraceProvider>
    </div>
  );
};

export default App;